import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'getm-search-result-item',
  templateUrl: './search-result-item.component.html',
  styleUrls: ['./search-result-item.component.scss'],
})
export class SearchResultItemComponent implements OnInit, OnChanges {

  @Input() nombre: string = '';
  @Input() variante: string = '';
  @Input() search: string = '';
  @Input() iconEnd: string | undefined;
  @Input() iconColor: string = 'getm-neutral-dark';
  @Input() imagenThumbnail: string | undefined;

  @Output() itemClick = new EventEmitter<void>();

  public highlightedName: string = '';

  constructor() { }

  ngOnInit(): void {
    this.updateHighlightedName();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['nombre'] || changes['search']) {
      this.updateHighlightedName();
    }
  }

  public onItemClick(): void {
    this.itemClick.emit();
  }

  private updateHighlightedName(): void {
    if (!this.search || !this.nombre) {
      this.highlightedName = this.nombre;
      return;
    }

    const regex = new RegExp(`(${this.escapeRegex(this.search)})`, 'gi');
    this.highlightedName = this.nombre.replace(regex, '<getm-neutral-dark style="font-weight: 700;">$1</getm-neutral-dark>');
  }

  private escapeRegex(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

}
